import { Component, Input, OnInit, ViewChild } from '@angular/core';
import {
  FormControl,
  FormGroupDirective,
  NgForm,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import jsPDF from 'jspdf';
import { MatTableDataSource } from '@angular/material/table';
import autoTable from 'jspdf-autotable';
import {
  Observable,
  startWith,
  map,
  take,
  tap,
  catchError,
  finalize,
  of,
  distinctUntilChanged,
  debounceTime,
  switchMap,
} from 'rxjs';
import { CompanySearch } from '../../../interfaces/company-search.interface';
import { TransactionHistoryElement } from '../../../interfaces/transaction-history-element.interface';
import { TransactionHistoryRequest } from '../../../interfaces/transaction-history-request.interface';
import { BackendAccessService } from '../../../Services/APICalls/backend-access-service';
import { MatSort, Sort } from '@angular/material/sort';
import { AuthService } from '../../../Services/Auth/auth.service';
import { UserProfileData } from '../../../interfaces/user-profile-data';
import { LoadingService } from '../../../Services/Loading/loading-service.service';
import { MatDialog } from '@angular/material/dialog';
import { NoDataBoxComponent } from './no-data-box/no-data-box.component';
import { TableComponent } from './table/table.component';

import { ErrorStateMatcher } from '@angular/material/core';
import { BranchSelectionService } from '../../../Services/branch-selection.service';
import { CanActivateService } from '../../../Services/CanActivate/can-activate.service';
import { TechsupportSelectedCompanyOptionService } from '../../../Services/techsupport-selected-company-option.service';
/* istanbul ignore next */
export class NoResultsErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(
    control: FormControl | null,
    form: FormGroupDirective | NgForm | null
  ): boolean {
    return !!(control && control.invalid && (control.dirty || control.touched));
  }
}

@Component({
  selector: 'app-transfer-history-page',
  templateUrl: './transfer-history-page.component.html',
  styleUrls: ['./transfer-history-page.component.scss'],

  standalone: false,
})
export class TransferHistoryPageComponent implements OnInit {
  @Input() currentView!: string;
  errorStateMatcher: ErrorStateMatcher = new NoResultsErrorStateMatcher();
  form!: UntypedFormGroup;
  company!: any;
  totalRows = 0;
  loading!: boolean;
  accountId!: string;
  sortColumn = 'date';
  pageSize = 5;
  currentPage = 0;
  showError: boolean = false;
  sortDescending = true;
  searchString: string = '';
  accountNumber!: string;
  businessId!: string;
  options: CompanySearch[] = [];
  doc!: any;
  localDateFormat = navigator.language;
  jsPDF!: any;
  noResults = false;
  currentSelection: string = 'transfers';
  noResultsFound2: boolean = false;
  transactionHistory!: MatTableDataSource<TransactionHistoryElement>;
  displayedColumns: string[] = [
    'date',
    'to',
    'productType',
    'quantity',
    'totalActive',
    'purchaseOrder',
    'notes',
  ];
  selectedBranch!: string;
  filteredOptions: Observable<CompanySearch[]> | undefined;

  constructor(
    private backend: BackendAccessService,
    public formBuilder: UntypedFormBuilder,
    public auth: AuthService,
    public loadingService: LoadingService,
    public dialog: MatDialog,
    private branchSelectionService: BranchSelectionService,
    private canActivate: CanActivateService,
    public selectedCompanyTS: TechsupportSelectedCompanyOptionService
  ) {}

  @ViewChild(MatPaginator)
  paginator!: MatPaginator;
  @ViewChild(MatSort)
  sort!: MatSort;
  @ViewChild(TableComponent) tableComponent!: TableComponent;
  /* istanbul ignore next */
  ngOnInit(): void {
    let roles: string[] = [];
    this.auth
      .getUserProfile$()
      .pipe(take(1))
      .subscribe((results: UserProfileData) => {
        // gets roles from JWT
        roles = results['http://allegion.com/claims/roles'];
        if (roles.some((role) => role === 'TechSupport')) {
        }
      });
    if (history.state.data) {
      this.currentView = history.state.data.transactionType;
    } else {
      this.currentView = 'transfers';
    }

    this.form = this.formBuilder.group({
      myControl2: new UntypedFormControl('', [Validators.required]),
    });
    this.loading = false;

    this.selectedCompanyTS.selectedOption$.subscribe((company) => {
      if (company) {
        console.log('Company changed:', company);
        this.form.controls['myControl2'].setValue(company);
        this.requestSupportTransactionHistoryData();
      }
    });

    this.filteredOptions = this.form.controls['myControl2'].valueChanges.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      startWith(''),
      map((value) => (typeof value === 'string' ? value : value.businessId)),
      switchMap((businessId) =>
        businessId ? this.loadCompanies(businessId) : of(this.options.slice())
      )
    );

    this.canActivate.companyProfile$.subscribe((companyProfile) => {
      if (companyProfile) {
        console.log('companyProfile', companyProfile);
        // this.company = companyProfile.companyAccountId;
        this.branchSelectionService.setCompanyName(companyProfile.companyName);
      }
    });
  }
  /* istanbul ignore next */
  optionSelected(option: any) {
    this.selectedCompanyTS.setSelectedOption(option);
    this.requestSupportTransactionHistoryData();
  }

  /* istanbul ignore next */
  viewToggler(event: any): void {
    if (this.currentView === 'transfers') {
      this.currentView = 'receipts';
      this.currentSelection = 'receipts';
      this.displayedColumns[1] = 'from';
      this.currentPage = 0;
    } else {
      this.currentView = 'transfers';
      this.currentSelection = 'transfers';
      this.displayedColumns[1] = 'to';
      this.currentPage = 0;
    }
    this.branchSelected(this.selectedBranch);
  }

  /* istanbul ignore next */
  viewTogglerTechSupport(event: any): void {
    if (
      !this.form.controls['myControl2'].value ||
      !this.form.controls['myControl2'].value.accountId
    ) {
      return; // ignore the click if no company is selected
    }
    if (this.currentView === 'receipts') {
      this.currentView = 'transfers';
      this.currentSelection = 'transfers';
      this.displayedColumns[1] = 'to';
      this.currentPage = 0;
    } else {
      this.currentView = 'receipts';
      this.currentSelection = 'receipts';
      this.displayedColumns[1] = 'from';
      this.currentPage = 0;
    }
    console.log('Toggled currentView:', this.currentView);
    this.requestSupportTransactionHistoryData();
  }

  /* istanbul ignore next */
  private _filter(value: string): CompanySearch[] {
    const filterValue = value.toLowerCase();

    return this.options.filter((option: CompanySearch) =>
      option.businessId.toLowerCase().includes(filterValue)
    );
  }
  /* istanbul ignore next */
  displayFn(company: any): string {
    return company && typeof company === 'object' && company.businessId
      ? `${company.businessId} (${company.accountNumber || 'N/A'}) ${
          company.addressCity
        }, ${company.addressState}`
      : '';
  }
  /* istanbul ignore next */
  loadCompanies(value: string): Observable<CompanySearch[]> {
    if (!value) {
      return of([]); // Don't call the API if the input is empty
    }
    this.loadingService.show();
    return this.backend.searchAccounts(value).pipe(
      tap((results: CompanySearch[]) => {
        this.options = results;
        this.noResultsFound2 = results.length === 0;
        this.form.controls['myControl2'].setErrors(
          this.noResultsFound2 ? { noResults: true } : null
        );
      }),
      catchError((error) => {
        this.loadingService.hide();
        return of([]); // Return an empty observable in case of an error
      }),
      finalize(() => this.loadingService.hide())
    );
  }

  /* istanbul ignore next */
  downloadPDF() {
    this.loading = true;

    // build request for all items
    const postData: TransactionHistoryRequest = {
      isrcpt: this.currentView !== 'transfers',
      istrn: this.currentView !== 'receipts',
      // frm: null,
      // to: null,
      srtclm: this.sortColumn,
      srtdsc: this.sortDescending,
      pgn: 0,
      prpg: this.totalRows,
      srchstr: this.searchString,
    };

    this.backend.getTransactionHistory(postData).subscribe({
      next: (results) => {
        //apply to table
        this.transactionHistory =
          new MatTableDataSource<TransactionHistoryElement>(
            results.creditHistoryTransactions
          );
        this.totalRows = results.totalRecordCount;

        // Yield to main thread so that the table can load into the DOM before being read.
        setTimeout(() => {
          // Build Report
          const doc = new jsPDF({
            orientation: 'landscape',
            unit: 'in',
          });
          autoTable(doc, {
            margin: { top: 0.8 },
            html: '#transfer_history_data_table',
            theme: 'striped',
            headStyles: {
              fillColor: '#000000',
              halign: 'left',
              valign: 'middle',
              cellWidth: 'wrap',
            },
            columns: [0, 1, 2, 3, 4, 5, 6],
            alternateRowStyles: { fillColor: '#F5F5F5' },
            didDrawPage: (data) => {
              // Header
              doc.text('History Report', 1.3, 0.5);
              doc.setTextColor('#000000');
              doc.setFontSize(20);
              const img = new Image();
              img.src = '../../../../assets/Logos/allegion-logo-mark.png';
              doc.addImage(img, 'png', 0.6, 0.1, 0.5, 0.5);
            },
          });
          doc.save('transfer_history_data_table.pdf');
          // Load previously filtered data into table
          this.requestSupportTransactionHistoryData();
        }, 0);
      },
      // on errors
      error: (error) => {
        this.togglePopup(), (this.loading = false);
      },
      // called once on completion

      complete: () => (this.loading = false),
    });
  }
  /* istanbul ignore next */
  requestTransactionHistoryData(brid?: string) {
    this.loading = true;
    const postData: TransactionHistoryRequest = {
      isrcpt: this.currentView !== 'transfers',
      istrn: this.currentView !== 'receipts',
      // frm: null,
      // to: null,
      srtclm: this.sortColumn,
      srtdsc: this.sortDescending,
      pgn: this.currentPage,
      prpg: this.pageSize,
      srchstr: this.searchString,
      brid: brid,
    };
    this.backend.getTransactionHistory(postData).subscribe({
      next: (results) => {
        this.transactionHistory =
          new MatTableDataSource<TransactionHistoryElement>(
            results.creditHistoryTransactions
          );
        this.totalRows = results.totalRecordCount;
      },
      // on errors
      error: (error) => {
        this.togglePopup();
        this.loading = false;
      },
      // called once on completion

      complete: () => (this.loading = false),
    });
  }

  /* istanbul ignore next */
  requestSupportTransactionHistoryData() {
    this.loading = true;
    const postData: TransactionHistoryRequest = {
      isrcpt: this.currentView !== 'transfers',
      istrn: this.currentView !== 'receipts',
      // frm: null,
      // to: null,
      srtclm: this.sortColumn,
      srtdsc: this.sortDescending,
      pgn: this.currentPage,
      prpg: this.pageSize,
      srchstr: this.searchString,
      acn: this.form.controls['myControl2'].value.accountNumber,
      aid: this.form.controls['myControl2'].value.accountId,
    };
    this.backend.getTransactionHistory(postData).subscribe({
      next: (results) => {
        if (results.creditHistoryTransactions.length === 0) {
          this.noResults = true;
          this.dialog.open(NoDataBoxComponent);
        } else {
          this.noResults = false;
          this.transactionHistory =
            new MatTableDataSource<TransactionHistoryElement>(
              results.creditHistoryTransactions
            );
          this.totalRows = results.totalRecordCount;
        }
      },
      // on errors
      error: (error) => {
        this.togglePopup(), (this.loading = false);
      },
      // called once on completion

      complete: () => (this.loading = false),
    });
  }
  /* istanbul ignore next */
  togglePopup() {
    if (this.showError) {
      this.showError = false;
    } else {
      this.showError = true;
    }
  }
  /* istanbul ignore next */
  applyFilter(filterValue: any) {
    this.searchString = filterValue;
    this.currentPage = 0;
    this.requestSupportTransactionHistoryData();
  }
  /* istanbul ignore next */
  sortChanged(sortState: Sort) {
    this.sortColumn = sortState.active;
    this.sortDescending = sortState.direction === 'desc' ? true : false;
    this.requestSupportTransactionHistoryData();
  }
  /* istanbul ignore next */
  pageChanged(event: PageEvent) {
    console.log('hit this 2');
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.requestSupportTransactionHistoryData();
  }

  branchSelected(branchId: string) {
    this.tableComponent.branchSelected.emit(branchId);
  }
}
